export const USER_LOGIN_REQUEST='USER_LOGIN_REQUEST'
export const USER_LOGIN_SUCCESS='USER_LOGIN_SUCCESS'
export const USER_LOGIN_FAILURE='USER_LOGIN_FAILURE'
// export const LINKURL = 'https://social-folks.herokuapp.com'

export const USER_LOGOUT='USER_LOGOUT'

export const USER_REGISTER_REQUEST='USER_REGISTER_REQUEST'
export const USER_REGISTER_SUCCESS='USER_REGISTER_SUCCESS'
export const USER_REGISTER_FAILURE='USER_REGISTER_FAILURE'
export const USER_REGISTER_RESET='USER_REGISTER_RESET'


export const USER_DETAILS_REQUEST='USER_DETAILS_REQUEST'
export const USER_DETAILS_SUCCESS='USER_DETAILS_SUCCESS'
export const USER_DETAILS_FAILURE='USER_DETAILS_FAILURE'
export const USER_DETAILS_RESET='USER_DETAILS_RESET'

export const ADMIN_USER_LIST_REQUEST='ADMIN_USER_LIST_REQUEST'
export const ADMIN_USER_LIST_SUCCESS='ADMIN_USER_LIST_SUCCESS'
export const ADMIN_USER_LIST_FAILURE='ADMIN_USER_LIST_FAILURE'
export const ADMIN_USER_LIST_RESET='ADMIN_USER_LIST_RESET'
